//IMPORT
import { History } from 'history';
import axios from 'axios';
import { CareAlert } from '../style/jellybook-component';
import { getApiToken } from '../utils';

//TYPE
interface IAjaxOption {
	url: string;
	method: 'GET' | 'POST' | 'PUT' | 'DELETE';
	headers?: any;
	params?: any;
	data?: any;
	baseURL?: string;
	cancelToken?: any;
}

interface IOnlyNumInputPayload {
	value: string;
	limitLen?: number;
	changeEvent: () => void;
}

export const getToken = () => localStorage.getItem('token') || sessionStorage.getItem('token');

export const networkError = (msg: string = '잠시후에 시도해주세요.'): void => {
	CareAlert.info({
		content: msg,
	});
};

export const isLogin = () => (getToken() ? true : false);

export const httpError = (history: History, code: number): void => {
	switch (code) {
		case 401:
			CareAlert.info({
				content: '로그인 후 이용해주세요.',
				ok: () => history.push('/login'),
			});
			break;
		case 403:
			history.push('/403');
			break;
		case 404:
			history.push('/404');
			break;
		case 500:
			networkError();
			break;
		default:
			networkError('잠시후 다시 시도해주세요.');
			break;
	}
};
export const amountCommas = (number: number): string => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const fileToBase64 = (file: File) => {
	return new Promise((resolve: (response: string | ArrayBuffer | null) => void) => {
		const fileReader = new FileReader();
		fileReader.readAsDataURL(file);
		fileReader.onload = () => resolve(fileReader.result);
	});
};

export const objToFormData = (obj: any) => {
	const formData = new FormData();
	Object.keys(obj).map((item) => formData.append(item, obj[item]));
	return formData;
};

export const $http = (option: IAjaxOption) => (useToken: boolean) => {
	if (useToken) {
		option.headers = {
			...option.headers,
			'authoried-token': getApiToken(),
		};
	}
	return axios(option);
};

export const $httpForMaster = (option: IAjaxOption) => (useToken: boolean) => {
	if (useToken) {
		option.headers = {
			...option.headers,
			'authoried-token': getToken(),
		};
	}
	return axios(option);
};

export const autoHyphen = (txt: string, use: 'PHONE' | 'BIRTH') => {
	if (use === 'PHONE') {
		return txt
			.replace(/[^0-9]/g, '')
			.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3')
			.replace('--', '-');
	} else {
		return txt
			.replace(/[^0-9]/g, '')
			.replace(/(^02.{0}|^01.{1}|[0-9]{4})([0-9]+)([0-9]{2})/, '$1-$2-$3')
			.replace('--', '-');
	}
};

export const onlyNumberInput = (payload: IOnlyNumInputPayload) => {
	const { value, limitLen, changeEvent } = payload;
	const onlyNumReg = /^[0-9]+$/g;
	if (value.match(onlyNumReg)) {
		if ((limitLen && value.length <= limitLen) || !limitLen) {
			changeEvent();
		}
	} else if (value === '') {
		changeEvent();
	}
};

export const isBirthDay = (date: string): boolean => {
	const [year, month, day] = date.split('-').map((item: string) => +item);
	const today = new Date();
	const nowYear = today.getFullYear();

	console.log(year, nowYear);

	// 다음해 입력 가능
	// if (year > nowYear) {
	// 	return false;
	// }
	if (month < 1 || month > 12) {
		return false;
	}
	if (day < 1 || day > 31) {
		return false;
	}
	if ((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
		return false;
	}
	if (month == 2) {
		const isleap = year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
		if (day > 29 || (day == 29 && !isleap)) {
			return false;
		} else {
			return true;
		}
	}
	return true;
};
